import type { IExtendedTelemetryItem } from '@microsoft/1ds-analytics-web-js';
import { loggerConstants } from './logger.constants';
import { LogRow } from './logger.log-row';
import { GlobalVariables } from 'app/services/globals';

export class EventRow extends LogRow {
    constructor(
        public readonly eventName: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        properties?: Record<string, any>,
        protected readonly measurements?: Record<string, number>) {
        super(properties);
    }

    public generateLoggingEntry(): IExtendedTelemetryItem {
        return { name: 'CustomEvents', data: { eventName: this.eventName, ...this.getStringifiedProperties(), ...this.measurements } };
    }

    public pushToAppInsights(): void {
        setTimeout(() => {
            if (GlobalVariables.enableAriaLogger) {
                oneDSWeb.trackEvent(this.generateLoggingEntry());
            } else if (this.eventName !== loggerConstants.Event_Dependency) {
                appInsights.trackEvent(this.eventName, this.getStringifiedProperties(), this.measurements);
            }
        }, 0);
    }
}
